import type { FieldValue } from '@components-shared/forms/formField.interface';
import {
  strengthValidate,
  newPasswordIsDifferFromOldOneValidate,
  isValidOnlyEngWithDigitsAndSpecialSymbols,
} from '@components-shared/forms/strengthPassword';
import type {
  NewPasswordDifferFromOldOneType,
  OnlyEngWithDigitsAndSpecialSymbolsType,
  StrengthValidatorType,
  ValidParams,
} from '@components-shared/forms/validators/interfaces';
import { keyMap } from '@locales/lokalise/keyMap';

export const validatePassword = () => {
  class ValidatorClassType {
    private _message = '';

    check = (value: FieldValue, params: ValidParams): boolean => {
      if (typeof value !== 'string') {
        return false;
      }

      if (!newPasswordIsDifferent.check(value, params)) {
        return false;
      }

      if (!strength.check(value)) {
        this._message = strength.message;
        return false;
      }

      if (!onlyEngWithDigitsAndSpecialSymbols.check(value, params)) {
        this._message = onlyEngWithDigitsAndSpecialSymbols.message;
        return false;
      }

      this._message = '';
      return true;
    };

    get message(): string {
      return this._message;
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return new ValidatorClassType() as { check: (value: FieldValue, params?: any) => boolean; message: string };
};

const newPasswordIsDifferent: NewPasswordDifferFromOldOneType = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  check: (value, params) => newPasswordIsDifferFromOldOneValidate(value, (params as any)?.form?.oldPassword),
  message: keyMap.formsValidationNewPasswordDifferFromOldOne,
};

export const strength: StrengthValidatorType = {
  check: (value) => strengthValidate(value),
  message: keyMap.formsValidationStrengthError,
};

const onlyEngWithDigitsAndSpecialSymbols: OnlyEngWithDigitsAndSpecialSymbolsType = {
  check: (value) => isValidOnlyEngWithDigitsAndSpecialSymbols(value),
  message: keyMap.formsValidationOnlyEnglishAndDigitsAndSpecialSymbolsError,
};
